import * as NewGameValidator from "../../state/NewGameValidator";
import { AppState } from "../../state/AppState";
import { GameState } from "../../state/GameState";
import { Player } from "../../state/TeamState";
import { RenamePlayerDialogState } from "../../state/RenamePlayerDialogState";

export function renamePlayer(appState: AppState): void {
    const game: GameState = appState.game;
    const renameDialogState: RenamePlayerDialogState | undefined = appState.uiState.dialogState.renamePlayerDialog;
    if (renameDialogState == undefined) {
        return;
    }

    renameDialogState.clearErrorMessage();

    const errorMessage: string | undefined = validatePlayer(appState);
    if (errorMessage != undefined) {
        renameDialogState.setErrorMessage(errorMessage);
        return;
    }

    const succeeded: boolean = game.tryUpdatePlayerName(
        renameDialogState.player.teamName,
        renameDialogState.player.name,
        renameDialogState.newName
    );

    if (!succeeded) {
        renameDialogState.setErrorMessage(
            "Couldn't rename the player. Make sure the name is unique on the team and try again."
        );
        return;
    }

    hideDialog(appState);
}

export function changeNewName(appState: AppState, newName: string): void {
    const renamePlayerDialog: RenamePlayerDialogState | undefined = appState.uiState.dialogState.renamePlayerDialog;
    if (renamePlayerDialog == undefined) {
        return;
    }

    renamePlayerDialog.setName(newName);
}

export function validatePlayer(appState: AppState): string | undefined {
    const renamePlayerDialog: RenamePlayerDialogState | undefined = appState.uiState.dialogState.renamePlayerDialog;
    if (renamePlayerDialog == undefined) {
        return "Dialog is closed";
    }

    const newPlayer: Player | undefined = new Player(
        renamePlayerDialog.newName,
        renamePlayerDialog.player.teamName,
        renamePlayerDialog.player.isStarter
    );

    // Trim the player name on submit, so the user can type in spaces while creating the name in the UI
    const trimmedPlayerName: string = newPlayer.name.trim();
    if (trimmedPlayerName.length === 0) {
        return "Player name cannot be blank";
    }

    if (appState.game.teamNames.indexOf(newPlayer.teamName) === -1) {
        return "Team doesn't exist";
    }

    const playersOnTeam: Player[] = [...appState.game.getPlayers(newPlayer.teamName), newPlayer];
    return NewGameValidator.newPlayerNameUnique(playersOnTeam, trimmedPlayerName);
}

export function hideDialog(appState: AppState): void {
    appState.uiState.dialogState.hideRenamePlayerDialog();
}
